import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import BrandLogo from '../brand-logo'
import TitleTreatmentImage from '../../title-treatment-image'
import styles from './show-page-heading.css'

// Renders either the title treatment image or the fallback brand logo and content title.
function ShowPageHeading({
  title,
  titleTreatment,
  brandLogo,
  e2eIdentifier
}) {
  const isLongTitle = title.length > 24

  if (titleTreatment) {
    return (
      <TitleTreatmentImage
        src={titleTreatment}
        alt="Title Treatment"
      />
    )
  }

  return (
    <>
      {/* Brand logo is for mobile view only */}
      <div className={styles.brandLogoContainer}>
        <BrandLogo logo={brandLogo} />
      </div>

      <h1
        className={classNames(styles.title, {
          [styles.isLongTitle]: isLongTitle
        })}
        data-lbx-e2e={e2eIdentifier}
      >
        {title}
      </h1>
    </>
  )
}

ShowPageHeading.propTypes = {
  title: PropTypes.string.isRequired,
  titleTreatment: PropTypes.string,
  brandLogo: PropTypes.string,
  e2eIdentifier: PropTypes.string
}

ShowPageHeading.defaultProps = {
  titleTreatment: '',
  brandLogo: '',
  e2eIdentifier: null
}

export default ShowPageHeading
